module.exports = __webpack_public_path__ + "img/logo.5ba2f092.png";